import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Zap, ArrowRight, AlertTriangle } from 'lucide-react';

export const DnoActionRequiredWidget = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/dno/inbox')
      .then((r) => setData(r.data))
      .catch(() => {});
  }, []);

  const count = data?.action_required_count || 0;
  if (count <= 0) return null;

  const top = (data.items || []).filter((i) => i.action_required).slice(0, 3);

  return (
    <Card className="border-amber-300 bg-amber-50/60" data-testid="dno-action-widget">
      <CardContent className="p-5">
        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center flex-shrink-0">
              <Zap className="w-5 h-5 text-amber-600" />
            </div>
            <div>
              <p className="font-semibold text-slate-900 flex items-center gap-2">
                <AlertTriangle className="w-4 h-4 text-amber-600" />
                {count} DNO {count === 1 ? 'application needs' : 'applications need'} your action
              </p>
              <p className="text-sm text-slate-600 mt-0.5">
                The DNO has emailed about these and we haven't replied yet.
              </p>
              <ul className="mt-2 space-y-1">
                {top.map((it) => (
                  <li key={(it.application_id || it.customer_id) + it.latest_email.when} className="text-xs text-slate-600">
                    <span className="font-medium text-slate-800">{it.customer_name || it.dno_reference}</span>
                    {it.summary ? <> — {it.summary}</> : null}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <Button asChild size="sm" className="bg-amber-600 hover:bg-amber-700 text-white" data-testid="dno-widget-open-btn">
            <Link to="/dno-inbox">
              Open DNO Inbox <ArrowRight className="w-4 h-4 ml-1.5" />
            </Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
